//NG+
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Compiler, ComponentFactoryResolver, Inject, Injectable, Injector } from "@angular/core";
import { SettingsMainComponent } from "./settings-components/settings-main.component";
import { MapController } from "../map/map-controller";
import { authAs, authType } from "../definitions";

export interface ISettingsDialogsServiceNg {
    showSettingsDialog(data: any, mapCtrl: MapController): any;
}

@Injectable({
    providedIn: 'root',
  })
export class SettingsDialogsServiceNg implements ISettingsDialogsServiceNg {
    public LoginDialog: any = null;
    //
    public constructor (
    @Inject(NgbModal) private modalService,
    @Inject(ComponentFactoryResolver) private componentFactoryResolver: ComponentFactoryResolver,
    @Inject(Compiler) private compiler: Compiler,
    @Inject(Injector) private injector: Injector) {
        //
    }
    //
    public showSettingsDialog(data:any, mapCtrl: MapController){
        let windowClass = 'modalSettingsMain';
        if (mapCtrl.userSettingsSrvs.isAuthForResource(authAs.control_settings_open_to_right, authType.object)) {
            windowClass = 'modalSettingsMainOpenRight';
        }
        const modalOpt = { backdrop: false, windowClass: windowClass, fullscreen:true, container:"#map-body-container" }
        return import('./settings-components/settings-main.module')
            .then((result) => {
                const modalRef = this.modalService.open(SettingsMainComponent, modalOpt);
                modalRef.componentInstance.data = data;
                return modalRef.result;
            })
    }
    //
}